export default "__VITE_ASSET__ChBj581h__"